import { Reveal } from "./Reveal";

export const SectionHeading = ({ chapter, kicker, title, lead, dark = false, testid }) => (
    <div className="max-w-3xl" data-testid={testid}>
        <Reveal>
            <p
                className={`font-mono text-xs font-semibold uppercase tracking-[0.25em] ${
                    dark ? "text-brand-orange" : "text-brand-orange"
                }`}
            >
                {chapter && <span className={dark ? "text-brand-cream/50" : "text-brand-muted"}>{chapter} / </span>}
                {kicker}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                className={`mt-4 font-display text-2xl font-bold leading-[1.1] tracking-tight sm:text-3xl lg:text-4xl ${
                    dark ? "text-brand-paper" : "text-brand-brown"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        {lead && (
            <Reveal delay={0.16}>
                <p className={`mt-5 text-sm leading-relaxed sm:text-base ${dark ? "text-brand-cream/75" : "text-brand-muted"}`}>
                    {lead}
                </p>
            </Reveal>
        )}
    </div>
);
